import { render, staticRenderFns } from "./MdtDisease.vue?vue&type=template&id=3a98474a&scoped=true"
import script from "./MdtDisease.vue?vue&type=script&lang=js"
export * from "./MdtDisease.vue?vue&type=script&lang=js"
import style0 from "./MdtDisease.vue?vue&type=style&index=0&id=3a98474a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98474a",
  null
  
)

export default component.exports